export default {
    parse: {
        prelude() {
            return this.createSingleNodeList(
                this.MediaQueryList()
            );
        },
        block(nested = false) {
            return this.Block(nested);
        }
    }
};
